(() => {
  const init = () => {
    document.querySelectorAll('.ut-share-bar').forEach((share) => {
      if (share.dataset.utReady === 'true') return;
      share.dataset.utReady = 'true';

      const status = share.querySelector('[data-ut-share-status]');

      const copyLink = async () => {
        try {
          await navigator.clipboard.writeText(share.dataset.shareUrl + '\n#U-Test');
          if (status) status.textContent = 'Link and #U-Test copied.';
        } catch {
          if (status) status.textContent = 'Copy this link and #U-Test: ' + share.dataset.shareUrl;
        }
      };

      const copyButton = share.querySelector('[data-ut-copy]');
      if (copyButton) copyButton.addEventListener('click', copyLink);

      const nativeButton = share.querySelector('[data-ut-native-share]');
      if (nativeButton) {
        nativeButton.addEventListener('click', async () => {
          if (!navigator.share) {
            await copyLink();
            if (status) status.textContent = 'Link and #U-Test copied. Paste them into Instagram.';
            return;
          }
          try {
            if (status) status.textContent = 'Choose Instagram if available. Otherwise use Copy link.';
            await navigator.share({
              title: share.dataset.shareTitle || document.title,
              text: '#U-Test',
              url: share.dataset.shareUrl,
            });
          } catch (error) {
            if (error && error.name === 'AbortError') {
              if (status) status.textContent = 'Share cancelled. Use Copy link to share on Instagram.';
            } else {
              await copyLink();
            }
          }
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
